export const EthioState = [
  'Addis Ababa',
  'Afar',
  'Amhara',
  'Benishangul-Gumuz',
  'Dire Dawa ',
  'Gambela',
  'Harari',
  'Oromia',
  'Sidama',
  'Somali',
  'South West',
  'SNNPR',
  'Tigray',
];

export const AddisSubCity = [
  'Addis Ketema',
  'Akaky Kaliti',
  'Arada',
  'Bole',
  'Gullele',
  'Kirkos',
  'Kolfe Keranio',
  'Lideta',
  'Nifas Silk-Lafto',
  'Yeka',
  'Lemi Kura',
];
